import { Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { selectUserInformation } from "../../State/Slices/UserInformationSlice";

function ProfileComponent() {
  const useStyles = makeStyles((theme) => ({
    root: {
      position: "absolute",
      top: "3vh",
      right: "4vw",
      zIndex: "5",
    },
    icon: {
      width: "2vmax",
      height: "2vmax",
      minWidth: "40px",
      minHeight: "40px",
      borderRadius: "50%",
      fontSize: "1vmax",
      color: "#fff",
      textAlign: "center",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      marginRight: "10px",
      [theme.breakpoints.down("sm")]: {
        width: "40px",
        height: "40px",
        fontSize: "20px",
      },
    },
    profile: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      borderRadius: "20px",
      paddingLeft: "20px",
      paddingRight: "20px",
      paddingTop: "2px",
      paddingBottom: "2px",
      transition: ".2s",
      cursor: "pointer",
      "&:hover": {
        background: "white",
        [theme.breakpoints.down("sm")]: {
          background: "none",
        },
      },
    },
    username: {
      [theme.breakpoints.down("sm")]: {
        display: "none",
      },
    },
  }));

  const classes = useStyles();
  const [color, setColor] = useState("");
  const user = useSelector(selectUserInformation);

  useEffect(() => {
    const val = (user?.email?.length ?? 0) % 4;
    switch (true) {
      case val <= 0: {
        setColor("#DE7171");
        break;
      }
      case val <= 1: {
        setColor("#DEA871");
        break;
      }
      case val <= 2: {
        setColor("#DEDE71");
        break;
      }
      case val <= 3: {
        setColor("#66896B");
        break;
      }
      case val <= 4: {
        setColor("#71DEA8");
        break;
      }
      default: {
        setColor("#C2C2C2");
        break;
      }
    }
  }, [user?.email, user?.nickname]);

  return (
    <Link to="/profile">
      <div className={classes.root}>
        <Grid container spacing={1} alignContent="center" justifyContent="center">
          <Grid container alignContent="center" justifyContent="center" className={classes.profile}>
            <div className={classes.icon} style={{ backgroundColor: color }}>
              {user?.nickname?.charAt(0)}
            </div>
            <div className={classes.username}>
              <span>{user.nickname}</span>
            </div>
          </Grid>
        </Grid>
      </div>
    </Link>
  );
}

export default ProfileComponent;
